import { App } from "@/model/App";

export interface dataFacets {
  apps: App[];
  categories: string[];
}
export interface aggregation {
  key: string;
  doc_count: string;
}

class DestoreService {
  parseFacet(facetsSelected: string[]) {
    return facetsSelected.map((facet) => {
      return facet.split("(")[0];
    });
  }

  paramsRoute(
    search: string,
    facets: string[]
  ): { q?: string; appCategories?: string } {
    if (search && facets.length > 0) {
      return {
        q: search,
        appCategories: facets.toString(),
      };
    } else if (search && facets.length === 0) {
      return { q: search };
    } else if (!search && facets.length > 0) {
      return { appCategories: facets.toString() };
    } else {
      return {};
    }
  }

  parseData(data: any): dataFacets {
    const dataToReturn: dataFacets = {
      apps: [],
      categories: [],
    };
    dataToReturn.categories = data.message.aggregation.map(
      (aggregation: aggregation) => {
        return aggregation.key + " (" + aggregation.doc_count + ")";
      }
    );
    if (data.message.hits.length > 0) {
      dataToReturn.apps = data.message.hits.map((app: any) => {
        return app._source;
      });
    }
    return dataToReturn;
  }
}

export default new DestoreService();
